import React from 'react';
import Navbar from './Navbar';

const ErrorAccessDM = () => {
  console.log('inside error')
  return (
    <div style={{ height: '100vh' }}>
      <Navbar />
      <div className='errorClass'>
          <h4>Sorry, couldn't retrieve the delivery metrics information at the moment. Please try after sometime.</h4>
            <p>Please reach to your DEX lead.</p>
        </div>

    </div>
  );
};

export default ErrorAccessDM;
